import { Link } from "react-router-dom";
import { ArrowUpRight, Cpu, Zap, Settings, CheckCircle2 } from "lucide-react";
import { company } from "../../data";

const FEATURES = [
  { icon: Cpu, title: "Engineering depth", body: "From components to commissioning — full-stack supply for labs and lines." },
  { icon: Zap, title: "Speed of dispatch", body: "Same-day dispatch on stocked SKUs from Patna. Pan-India shipping." },
  { icon: Settings, title: "Calibrated quality", body: "Every measurement and trainer kit is bench-tested before it ships." },
  { icon: CheckCircle2, title: "100% satisfaction", body: "Service-first culture. Our work is judged by the next purchase order." },
];

export default function AboutTeaser() {
  return (
    <section className="border-y border-ink-700 bg-ink-900/40" data-testid="about-teaser">
      <div className="section-padding py-24 lg:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="overline mb-3">// Since 2013</p>
          <h2 className="h-display text-4xl md:text-5xl mb-8">
            Solutions for education, automation &amp; industries.
          </h2>
          <p className="text-textmuted font-mono text-sm leading-relaxed mb-6">
            {company.description}
          </p>
          <Link to="/about" className="btn-ghost" data-testid="about-teaser-cta">
            Read the story <ArrowUpRight size={14} />
          </Link>
        </div>
        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 grid-cells">
          {FEATURES.map(({ icon: Icon, title, body }) => (
            <div key={title} className="p-8 hover-lift">
              <Icon size={20} strokeWidth={1.5} className="text-signal-amber mb-5" />
              <p className="font-display font-bold text-lg mb-2">{title}</p>
              <p className="font-mono text-xs text-textmuted leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
